import { render, staticRenderFns } from "./Tuin.vue?vue&type=template&id=b15cafce&scoped=true&"
import script from "./Tuin.vue?vue&type=script&lang=ts&"
export * from "./Tuin.vue?vue&type=script&lang=ts&"
import style0 from "./Tuin.vue?vue&type=style&index=0&id=b15cafce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15cafce",
  null
  
)

export default component.exports